import { Surveys } from "modules/Surveys/surveys";
import { BlockTypes, getBlockFullType } from "./blocks";
import { SurveyBlocks } from "../surveyBlocks";

export const getSurveyTree = (survey: Surveys.Survey): Blockable => {
  const tree = {
    id: survey.id,
    objectId: survey.objectId,
    title: survey.title || "",
    blockType: BlockTypes.MainSurvey,
    parentSurveyId: "",
    isExpanded: true,
    [BlockNestedKey]: survey.surveyBlocks
      .sort((a, b) => a.order - b.order)
      .map((block) => ({
        id: block.id,
        objectId: block.objectId,
        title: block.contentObject.title || "",
        blockType: getBlockFullType(block.contentType, block.contentObject.type),
        options: block.contentObject.options,
        parentSurveyId: survey.objectId,
      })),
  };

  return tree;
};

export const isMainSurvey = (block: Surveys.Survey | SurveyBlocks.Block) => {
  return !("contentObject" in block);
};
export const isSurvey = (block: Surveys.Survey | SurveyBlocks.Block) => {
  return "contentObject" in block && block.contentType === BlockTypes.Survey;
};

export const getParentPath = (path: string) => path.replace(/\["\w*"\]\[\d+\]$/, "");
export const setPathNewIndex = (path: string, index: number) => path.replace(/\[\d+\]$/, `[${index}]`);

export const BlockNestedKey = "nested";

export const blockToBlockable = (block: SurveyBlocks.Block): Blockable => {
  return {
    id: block.id,
    objectId: block.objectId,
    parentSurveyId: block.surveyId,
    title: block.contentObject.title ?? '',
    blockType: getBlockFullType(block.contentType, block.contentObject.type),
    options: block.contentObject.options,
  };
}

export interface Blockable {
  id: string | number;
  objectId: string | number;
  parentSurveyId: string | number;
  title: string;
  blockType: BlockTypes;
  isExpanded?: boolean;
  isGettingNested?: boolean;
  [BlockNestedKey]?: Blockable[];
  options?: string[];
}
